var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 16,
    viewBox: "0 0 8 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.30445 -6.0807e-08C7.48125 -4.5351e-08 7.65804 0.0646 7.79762 0.203028C8.06746 0.470655 8.06746 0.913628 7.79762 1.18126L1.73074 7.19827C1.2841 7.64124 1.2841 8.36107 1.73074 8.80404L7.79762 14.8211C8.06746 15.0887 8.06746 15.5317 7.79762 15.7993C7.52777 16.0669 7.08113 16.0669 6.81128 15.7993L0.744403 9.78226C0.269846 9.31161 6.40386e-07 8.67484 6.99281e-07 8.00115C7.58177e-07 7.32747 0.260541 6.6907 0.744403 6.22004L6.81128 0.203028C6.95086 0.0738277 7.12766 -7.62629e-08 7.30445 -6.0807e-08Z",
    fill: "#0b8369"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.b97a57d8241a88df5f938964717105e8.svg";
export { ForwardRef as ReactComponent };